import React, { useEffect, useState } from "react";
import CustomerStatement from "../../../../../entities/DashboardPage/AccountingModule/Customer/CustomerStatement";
// import AuthService from "../../../../../api/AuthService";
import { useLocation, useNavigate } from "react-router-dom";

// import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
// import { useAlert } from "../../../../../context/AlertContext";

const CustomerStatementPage = () => {
  // const [data,setData] = useState([]);
  // console.log(data, "suppdata")

  const [customerList, setCustomerList] = useState([])
  const { state } = useLocation();

  useEffect(() => {
    const customerList = state.customerList.map(({ _id, name, billingAddress, email }) => ({
      _id,
      name,
      billingAddress,
      email
    }))
    setCustomerList(customerList)
  }, [])


  return (
    <CustomerStatement
      customerList={customerList}
    />
  )

}

export default CustomerStatementPage;
